<template>
    <div>
        <transition appear appear-active-class="fade-enter-active" leave-active-class="fade-leave-active">
            <div>
                <p>Il est important d'encadrer la vente de vos services (packs, options...) avec un document juridique,
                    plus
                    communément appelé CGV (conditions générales de vente)</p>
                <p>En résumé, ce document est destiné à préciser les conditions des échanges entre les deux parties (vos
                    partenaires/adhérents et vous) et vous protègent en cas de litige ou d'imprévu.
                </p>
                <p>C'est à vous de rédiger ce document. Celui-ci, après import sur Uska, est signé électroniquement par
                    l'acheteur lors de la validation de son paiement. Il confirme avoir lu et accepté le document en
                    question.</p>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "CguCadhField"
}
</script>
